/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_011: Question = {
  id: 'multi-011-programme-ruelles-vertes',
  oldId: '72',
  title: 'Programme de ruelles vertes ou Bleues-Vertes',
  number: '7.3',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 12,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_multi_011__v3: Question = {
  ...question_multi_011,
  title: 'Mise en œuvre de rue ou ruelles vertes ou Bleues-Vertes',
};

export const question_multi_011_v2: Question = question_multi_011;
export const question_multi_011_v3: Question = question_multi_011__v3;
